import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {WriteOffService} from '../service/write-off.service';
import {InvestormenuModule} from '../investormenu/investormenu.module';
import {CommonSectionsModule} from '../views/common/common-sections.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {LenderDelayedLoansComponent} from './lender-delayed-loans.component';
import {HorizontalLoaderModule} from '../horizontal-loader/horizontal-loader.module';
import {LenderDelayedLoansRoutingModule} from './lender-delayed-loans-routing.module';
import {LenderWriteOffLoansComponent} from './lender-write-off-loans/lender-write-off-loans.component';
import {IndianCurrencyFormatterModule} from '../views/common/indian-currency-formatter/indian-currency-formatter.module';
import {MatButtonModule, MatTooltipModule} from '@angular/material';
import {LoanListComponent} from './loan-list/loan-list.component';
import {NonNpaDelayedLoanFilterPipe, NpaLoanFilterPipe} from './filters/loan-list.pipe';
import {NpaLoansFilter} from './filters/npa-loans.filter';
import {LenderSettledLoansComponent} from './lender-settled-loans/lender-settled-loans.component';
import {LoanSettlementService} from '../service/loan-settlement.service';
import {LenderReturnCalculator} from '../service/lender-return-calculator';
import {PaymentDateTextColorPipe} from '../utils/pipes/payment-date-text-color.pipe';
import {PipesModule} from '../utils/pipes/pipes.module';
import {RestructuredLoansComponent} from './restructured-loans/restructured-loans.component';
import {LoanRestructureService} from '../service/loan-restructure.service';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    imports: [LenderDelayedLoansRoutingModule, CommonModule, RouterModule, CommonSectionsModule, InvestormenuModule, MatButtonModule,
        MatTableModule, MatTabsModule, MatSortModule, MatProgressSpinnerModule, HorizontalLoaderModule,
        IndianCurrencyFormatterModule, PipesModule, MatTooltipModule, TooltipModule],
    declarations: [LenderDelayedLoansComponent, LenderWriteOffLoansComponent, LoanListComponent, NpaLoanFilterPipe, NonNpaDelayedLoanFilterPipe, LenderSettledLoansComponent, RestructuredLoansComponent],
    providers: [WriteOffService, NpaLoansFilter, LoanSettlementService, LenderReturnCalculator, PaymentDateTextColorPipe, LoanRestructureService]
})
export class LenderDelayedLoansModule {
}
